// Ids of DockablePanels currently open, so callers can avoid stealing focus from one.
const openPanels = new Set();

export const markPanelOpen = (uid, open) => {
  if (open) openPanels.add(uid);
  else openPanels.delete(uid);
};

export const isAnyPanelOpen = () => openPanels.size > 0;
